import request from 'request'

export default (options) => new Promise((resolve, reject) => {
  request(options, (error, response, body) => {
    if (error) return reject(error)
    return resolve(Object.assign({}, response, { body }))
  })
})
